'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { createContext } from '~logic/lib/react';
import { jsx as _jsx } from "react/jsx-runtime";

var _createContext = createContext("RouteContext"),
    _createContext2 = _slicedToArray(_createContext, 2),
    Provider = _createContext2[0],
    useRouteCtx = _createContext2[1];

/**
 * provide once parsed URL (in SS page code) to the whole app
 * to be able to use it wherever it’s needed (eg. in routing)
 */
export var RouteContextProvider = function RouteContextProvider(_ref) {
  var children = _ref.children,
      contextValue = _ref.contextValue;
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
};
export { useRouteCtx };